<template>
  <div></div>
</template>

<script>
export default {
  name: 'news-promotion'
}
</script>
